import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import {MenuButtonUnindent} from 'mui-tiptap';

const StyledEditorMenuButtonUnindent = styled(MenuButtonUnindent)`
  ${ComponentStyles}
`;

StyledEditorMenuButtonUnindent.propTypes = {
  theme: PropTypes.object
};

export default StyledEditorMenuButtonUnindent;
